import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
  return (
    <>
      <Header />
      <main style={{ minHeight: 'calc(100vh - 130px)', padding: '20px' }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
